import React from "react";
import { PopupButton } from "@typeform/embed-react";

import { useEventTracker } from "hooks/useEventTracker";
import { Action, Category } from "utils/trackEvent";

export default function FeedbackSurvey({ surveyId }: { surveyId: string }) {
  const { publishEvent } = useEventTracker();

  return (
    <div className="text-center text-white bg-default text-sm py-md">
      <PopupButton
        id={surveyId}
        autoClose={3}
        shareGaInstance={true}
        onSubmit={() => {
          publishEvent({
            action: Action.click,
            category: Category.feedbackSurvey,
            label: "feedback submitted",
          });
        }}
        onReady={() => {
          publishEvent({
            action: Action.click,
            category: Category.feedbackSurvey,
            label: "open survey",
          });
        }}
      >
        Website feedback?&nbsp;&nbsp;
        <span className="underline">let Leafly know</span>
      </PopupButton>
      <style jsx>
        {`
          .tf-v1-widget {
            z-index: 99999 !important;
          }
        `}
      </style>
    </div>
  );
}
